<template>
  <div class="card mb-3 p-0">
    <div class="card-header">{{ header }}</div>
    <div class="card-body d-flex align-items-center">
      <div class="float-right">
        <i v-if="isActive" class="dx-icon dx-icon-minus"></i>
        <i v-if="isError" class="dx-icon dx-icon-info text-danger"></i>
        <i v-if="isSuccess" class="dx-icon dx-icon-check text-success"></i>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mped-fact-file-uploader-step',
};
</script>

<script setup>
import { defineProps, computed } from 'vue';

const { state, header } = defineProps({
  state: {
    type: String,
    default: 'disabled',
  },
  header: {
    type: String,
    default: 'header',
  },
});

const isActive = computed({
  get: () => state === 'active',
});

const isSuccess = computed({
  get: () => state === 'success',
});

const isError = computed({
  get: () => state === 'error',
});

</script>

<style scoped>

</style>
